<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-select v-model="ownerId" :options="owners" placeholder="placeholder.pleaseSelectOwner" @change="onOwnerChange"/>
      <vxe-select v-model="inventoryState" :options="inventoryStates" placeholder="placeholder.inventoryStatus"/>
      <vxe-button content="button.taken" size="mini" status="primary" @click="fetch"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="primary" @click="reset"/>
      <vxe-button :disabled="this.data.length===0" :loading="loading" content="button.save" size="mini" status="primary" @click="save"/>
      <a-popconfirm :title="$t('title.selectedDetailsWillBeDeleted')" @confirm="remove">
        <vxe-button content="button.delete" size="mini" status="error"/>
      </a-popconfirm>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      size="mini"
      :height="height"
      keep-source
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      :edit-config="editConfig"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="checkbox" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="inventoryState" title="business.label.inventoryState">
        <template #default="{row}">
          {{inventoryStates.find(item => item.ordinal === row.inventoryState).name}}
        </template>
      </vxe-column>
      <vxe-column :edit-render="{name:'VxeInput',events:{click:({row})=>this.selectReason(row)}}" field="reason.name" title="title.reason"/>
    </vxe-table>
    <InventoryModal ref="inventoryModal" @change="changeInventory"/>
    <field-modal ref="reasonModal" :show-name="true" :show-no="false" :show-value="false" :title="$t('title.reason')" no="REASON" @change="(rlt,row)=>row.reason=changeReason(rlt[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { findAll, findEnum, post } from '@/api/Api'
import InventoryModal from '@/views/modal/InventoryModal.vue'
import Api from '@/api'
import FieldModal from '@/views/modal/FieldModal.vue'
import { Dictionary } from '@/api/dto/admin/Dictionary'

export default {
  name: 'InventoryStatusChange',
  components: { FieldModal, InventoryModal },
  data() {
    return {
      loading: false,
      data: [],
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      owners: [],
      ownerId: undefined,
      inventoryState: undefined,
      inventoryStates: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8525),
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true }
    }
  },
  created() {
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStates = res.result
      }
    })
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = res.result
      }
    })
  },
  methods: {
    onOwnerChange() {
      if (this.data.length !== 0) {
        this.data = []
      }
    },
    fetch() {
      if (!this.ownerId) {
        return this.$message.warning('请先选择货主')
      }
      const args = { 'owner.id': this.ownerId, available: true, physical: true }
      this.$refs.inventoryModal.open(args)
    },
    remove() {
      this.$refs.table.removeCheckboxRow().then(() => {
        this.data = this.$refs.table.tableData
      })
    },
    save() {
      if (!this.verify()) {
        return
      }
      this.loading = true
      const order = {
        orderType: { id: '560465299032371223' },
        owner: { id: this.ownerId },
        dataSource: 4,
        warehouse: { id: this.warehouse.id },
        details: [],
        inspector: this.operator.name,
        inventoryState: this.inventoryState
      }
      order.details = this.data.map(item => {
        return {
          sku: { id: item.sku.id },
          quantity: item.quantity,
          location: { id: item.location.id },
          container: item.container === null ? null : { id: item.container.id },
          inventoryState: item.inventoryState,
          reason: item.reason.skipNulls()
        }
      })
      post(Api.conversionConverterSubmit, { type: this.type }, order).then(res => {
        if (res.success) {
          this.data = []
          this.$message.success('保存成功')
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.data = []
      this.ownerId = undefined
      this.inventoryState = undefined
    },
    changeInventory(data) {
      this.data = data.map(item => {
        const detail = JSON.parse(JSON.stringify(item))
        detail.quantity = item.inventory.availableQuantity
        detail.inventoryState = item.inventory.inventoryState
        detail.reason = new Dictionary()
        return detail
      })
    },
    selectReason(row) {
      this.$refs.reasonModal.open(null, row)
    },
    changeReason(data) {
      return new Dictionary(data)
    },
    verify() {
      let pass = true
      if (this.inventoryState === undefined) {
        this.$message.warning('请选择库存状态')
        pass = false
        return pass
      }
      return pass
    }
  }
}
</script>